import { loadExternalScript } from './loadExternalScript';

export const ensurePlaceToPayLoaded = async () => {
  if (window.P) return;

  await loadExternalScript({
    src: 'https://checkout.placetopay.com/lightbox.min.js',
    id: 'placetopay-lightbox-sdk',
  });

  if (!window.P) {
    throw new Error('PlaceToPay SDK was not initialized correctly');
  }
};
